var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQ4Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.793 223.769C111.892 222.419 113.99 220.921 115.944 219.423C139.642 202.622 162.14 186.724 195.59 206.075C197.54 206.075 199.936 206.075 202.486 205.921C218.837 205.321 243.437 204.423 254.684 215.822C257.234 218.371 258.886 221.372 259.784 224.969C248.235 234.567 218.688 238.317 204.436 239.667C203.389 239.82 202.486 240.867 202.64 241.918C202.789 242.97 203.687 243.868 204.738 243.719C220.335 242.067 254.386 237.568 265.186 224.071C265.786 223.471 266.233 222.722 266.684 221.973C281.983 211.02 302.233 197.225 316.481 201.422C321.581 202.925 325.331 206.521 327.583 212.37C328.183 213.723 327.732 215.52 326.382 216.422C314.834 224.369 304.634 231.869 295.635 238.62C251.534 271.463 229.185 288.11 155.542 268.615L140.992 277.162L109.793 223.769Z",
    fill: "#435B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.935 210.573C263.534 204.423 276.884 196.025 287.683 198.574C289.935 199.174 291.885 200.072 293.532 201.422C282.733 206.223 272.086 213.872 264.586 219.12L263.985 219.572L263.534 220.321C263.236 220.772 262.934 221.372 262.487 221.819C261.435 218.669 259.635 215.822 257.234 213.421C256.187 212.369 255.135 211.471 253.935 210.573Z",
    fill: "#435B63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.842 304.909C112.641 304.909 111.441 304.309 110.845 303.258L72.5925 237.716C72.1456 236.967 71.9966 236.069 72.1456 235.167C72.4435 234.269 73.0437 233.52 73.7929 233.068L98.6913 218.52C100.343 217.622 102.442 218.068 103.344 219.72L141.592 285.113C142.192 286.011 142.192 286.909 142.043 287.811C141.741 288.56 141.29 289.309 140.392 289.761L115.493 304.458C114.893 304.761 114.442 304.909 113.842 304.909Z",
    fill: "#435B63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.936 199.323C223.038 199.323 222.285 199.025 221.536 198.425C197.088 173.976 171.888 148.628 171.888 122.834C171.888 107.536 184.339 95.0859 199.638 95.0859C211.638 95.0859 218.539 100.785 223.936 109.635C229.487 100.785 236.235 95.0859 248.384 95.0859C263.683 95.0859 276.134 107.536 276.134 122.834C276.134 148.628 250.785 173.976 226.337 198.425C225.737 199.025 224.835 199.323 223.936 199.323Z",
    fill: "#435B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ4Icon1);
export default __webpack_public_path__ + "static/media/q4-icon1.7d5bebccd9aebe62f67b3f234b0fe2d5.svg";
export { ForwardRef as ReactComponent };